var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUngroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.602,
    height: 18.602,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ungroup_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5200f1",
    stroke: "#5200f1",
    d: "M0 .03h18.711v18.295H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ungroup_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5200f1",
    stroke: "#5200f1",
    d: "M1226.281 465.752h18.711v18.295h-18.711z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ungroup_svg__c",
    x: 0,
    y: 0,
    width: 32.709,
    height: 32.709,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 685",
    transform: "translate(-1226.281 -465.722)",
    clipPath: "url(#ungroup_svg__a)",
    opacity: 0.236
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#5200f1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 349",
    d: "M1243.568 470.53l-7.776-3.466a.723.723 0 00-.592 0l-7.768 3.466a.728.728 0 00-.046 1.306l7.772 4.145a.729.729 0 00.685 0l7.772-4.145a.727.727 0 00-.047-1.306z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 350",
    d: "M1242.929 473.63l-7.429 3.964-7.429-3.963a.728.728 0 00-.685 1.284l7.772 4.146a.729.729 0 00.685 0l7.772-4.146a.728.728 0 00-.686-1.284z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 351",
    d: "M1242.929 476.477l-7.429 3.958-7.429-3.958a.728.728 0 10-.685 1.284l7.772 4.145a.726.726 0 00.685 0l7.772-4.145a.728.728 0 10-.686-1.284z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ungroup_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.827 -.196)",
    filter: "url(#ungroup_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.814 16.003l2.652-2.652-2.652-2.652a.625.625 0 01.884-.883l2.652 2.651 2.652-2.651a.625.625 0 01.884.883l-2.652 2.652 2.652 2.652a.625.625 0 11-.884.884l-2.652-2.652-2.652 2.652a.625.625 0 11-.884-.884z",
    "data-name": "Union 1",
    fill: "#5300f2",
    stroke: "#5300f2",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroup);
export default __webpack_public_path__ + "static/media/ungroup.4db01321a905e743b86010a075ba4a95.svg";
export { ForwardRef as ReactComponent };